import React from 'react';
import Layout from 'Layout/Layout';
import Loader from 'Layout/Loader';

export class ShoppingCartThankYouPlaceholderComponent extends React.Component {
    render() {
        return (
            <Layout page="thnk-you">
                <div className="full-height">
                    <Loader />
                </div>
            </Layout>
        );
    }
}

export default ShoppingCartThankYouPlaceholderComponent;
